import { CertificateProgramTestimonialSource } from '@mc/api'
import { TrackingRow } from 'pages/certificates/components/TrackingRow'
import { LinkedInTestimonialsContent } from './LinkedInTestimonialsContent'
import { type Testimonial } from './types'

interface LinkedInTestimonialsSectionProps {
  testimonials?: Testimonial[]
  title?: string
}

export const LinkedInTestimonialsSection = ({
  testimonials,
  title,
}: LinkedInTestimonialsSectionProps) => {
  const supportedTestimonials = (testimonials ?? []).filter(
    (testimonial) =>
      !testimonial.source ||
      testimonial.source === CertificateProgramTestimonialSource.LINKEDIN,
  )

  if (!supportedTestimonials.length) return null

  return (
    <TrackingRow
      row_name='linkedin-testimonials'
      location='linkedin-testimonials'
    >
      <LinkedInTestimonialsContent
        testimonials={supportedTestimonials}
        title={title}
      />
    </TrackingRow>
  )
}
